import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=4129eb1e&scoped=true&"
import script from "./TagList.vue?vue&type=script&lang=ts&"
export * from "./TagList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4129eb1e",
  null
  
)

export default component.exports